import script from "./AddVendorsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AddVendorsView.vue?vue&type=script&setup=true&lang=js"

import "./AddVendorsView.vue?vue&type=style&index=0&id=17660d0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17660d0a"]])

export default __exports__